// AUTO-GENERATED by scripts/build-icons.mjs — do not edit by hand.
import { createSvgIconFromGenerated } from '../utils'

import SvgAmazonMada from './svg-amazon-mada'
import SvgAmazonMastercard from './svg-amazon-mastercard'
import SvgAmazonVisa from './svg-amazon-visa'
import SvgCircleLogoAmericanExpress from './svg-circle-logo-american-express'
import SvgCircleLogoDinersClub from './svg-circle-logo-diners-club'
import SvgCircleLogoJcb from './svg-circle-logo-jcb'
import SvgCircleLogoMastercard from './svg-circle-logo-mastercard'
import SvgCircleLogoVisa from './svg-circle-logo-visa'
import SvgFlagCz from './svg-flag-cz'
import SvgFlagPl from './svg-flag-pl'
import SvgFlagSk from './svg-flag-sk'

export const AmazonMadaIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgAmazonMada, 'AmazonMada')
export const AmazonMastercardIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgAmazonMastercard, 'AmazonMastercard')
export const AmazonVisaIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgAmazonVisa, 'AmazonVisa')
export const CircleLogoAmericanExpressIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCircleLogoAmericanExpress, 'CircleLogoAmericanExpress')
export const CircleLogoDinersClubIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCircleLogoDinersClub, 'CircleLogoDinersClub')
export const CircleLogoJcbIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCircleLogoJcb, 'CircleLogoJcb')
export const CircleLogoMastercardIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCircleLogoMastercard, 'CircleLogoMastercard')
export const CircleLogoVisaIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCircleLogoVisa, 'CircleLogoVisa')
export const FlagCzIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFlagCz, 'FlagCz')
export const FlagPlIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFlagPl, 'FlagPl')
export const FlagSkIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFlagSk, 'FlagSk')
